import { useEffect } from 'react';
import PageLayout from '../components/PageLayout';
import RoadmapSection from '../components/RoadmapSection';

const Roadmap = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <PageLayout title="Roadmap">
      <RoadmapSection />
    </PageLayout>
  );
};

export default Roadmap;
